<template>
  <div>
    <!-- Tabla -->
    <div class="mt-2 hidden lg:block">
      <div
        class="min-w-full overflow-hidden overflow-x-auto align-middle shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Comprobante
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Descripción
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Vencimiento
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Fecha de pago
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Monto
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Estado
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Acciones
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-for="(deuda, index) in deudas" :key="index" class="bg-white">
              <td class="whitespace-nowrap px-6 py-4 text-left text-sm text-gray-500">
                {{ deuda.comprobante.numero_comprobante.trim() }}
              </td>

              <td class="px-6 py-4 text-left text-sm text-gray-500">
                <p class="line-clamp-2" :title="deuda.descripcion">{{ deuda.descripcion }}</p>
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-left text-sm text-gray-500">
                <span v-if="deuda.vencimiento_vigente">
                  {{
                    deuda.vencimiento_vigente.fecha_vencimiento
                      | date('America/Buenos_Aires', 'DD-MM-Y')
                  }}
                </span>
                <span v-else>-</span>
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-left text-sm text-gray-500">
                <span v-if="deuda.pago">
                  {{ deuda.pago.fecha_pago | dateTime('America/Buenos_Aires', 'DD-MM-Y H:mm') }}
                </span>
                <span v-else>-</span>
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-right text-sm text-gray-500">
                {{ deuda.vencimiento_vigente.monto | currency }}
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-center text-sm text-gray-500">
                <div class="flex flex-row space-x-2">
                  <span
                    class="rounded-lg px-2 py-0.5 text-center font-medium"
                    :class="[backgroundColor(deuda.estado_actual), textColor(deuda.estado_actual)]"
                  >
                    {{ textoEstado(deuda.estado_actual) }}
                  </span>

                  <span
                    v-if="deuda?.estado_actual?.estado?.id.trim() == 'PAGADO'"
                    class="rounded-lg p-1 text-center font-medium"
                    :class="[backgroundColor(deuda.estado_actual), textColor(deuda.estado_actual)]"
                    v-tippy="deuda?.pago?.medio_pago?.descripcion.trim()"
                    >{{ deuda?.pago?.medio_pago?.id.trim() }}</span
                  >
                </div>
              </td>

              <td
                class="whitespace-nowrap px-6 py-4 text-center text-sm"
                v-if="!hideActions(deuda.estado_actual)"
              >
                <button
                  v-if="!validCategory(deuda.tipo.categoria.id.trim())"
                  @click="
                    $router.push({
                      name: 'ver-comprobante',
                      params: { nroComprobante: deuda.comprobante.numero_comprobante.trim() },
                    })
                  "
                  title="Ver comprobante"
                  class="rounded-full bg-white p-1 text-gray-400"
                >
                  <BoxIconFile class="h-6 w-6 fill-current" />
                </button>
                <button
                  v-if="deuda.estado_actual.estado.id.trim() == 'PAGADO'"
                  @click="
                    $router.push({
                      name: 'ver-recibo',
                      params: { nroComprobante: deuda.comprobante.numero_comprobante.trim() },
                    })
                  "
                  title="Ver recibo"
                  class="rounded-full bg-white p-1 text-gray-400"
                >
                  <BoxIconReceipt class="h-6 w-6 fill-current" />
                </button>
                <button
                  v-if="deuda.estado_actual.estado.habilita_pago"
                  @click="
                    $router.push({ name: 'pagar-comprobante', params: { idDeuda: deuda.id } })
                  "
                  title="Pagar comprobante"
                  class="rounded-full bg-white p-1 text-gray-400"
                >
                  <BoxIconDollarCircle class="h-6 w-6 fill-current" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Cards -->
    <div class="grid gap-3 lg:hidden">
      <div
        v-for="(deuda, index) in deudas"
        :key="index"
        class="flex items-center rounded-lg border-2 border-gray-200 bg-white p-4 md:justify-center md:px-0"
      >
        <div class="mx-auto flex flex-1 flex-col items-center justify-around space-y-4">
          <div class="space-y-2 text-center">
            <div>
              <p class="text-sm font-bold tracking-wide text-gray-600">
                Comprobante: {{ deuda.comprobante.numero_comprobante }}
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                Descripción: {{ deuda.descripcion }}
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                Fecha de vencimiento:
                {{
                  deuda.vencimiento_vigente.fecha_vencimiento
                    | date('America/Buenos_Aires', 'DD-MM-Y')
                }}
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                Fecha de pago:
                <span v-if="deuda.pago">
                  {{ deuda.pago.fecha_pago | dateTime('America/Buenos_Aires', 'DD-MM-Y H:mm') }}
                </span>
                <span v-else>-</span>
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                Monto: {{ deuda.vencimiento_vigente.monto | currency }}
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                Estado:
                <span
                  class="rounded-lg px-2 py-0.5 text-center font-medium"
                  :class="[backgroundColor(deuda.estado_actual), textColor(deuda.estado_actual)]"
                >
                  {{ textoEstado(deuda.estado_actual) }}
                </span>
              </p>
            </div>

            <div
              class="space-y-2 sm:space-x-2 sm:space-y-0"
              v-if="!hideActions(deuda.estado_actual)"
            >
              <button
                v-if="!validCategory(deuda.tipo.categoria.id.trim())"
                @click="
                  $router.push({
                    name: 'ver-comprobante',
                    params: { nroComprobante: deuda.comprobante.numero_comprobante.trim() },
                  })
                "
                class="focus:shadow-outline inline-flex w-full items-center justify-center space-x-2 rounded-md border border-gray-300 bg-white px-4 py-3 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:border-blue-300 focus:outline-none sm:w-max"
              >
                <BoxIconFile class="h-5 w-5 fill-current" />
                <span>Ver comprobante</span>
              </button>
              <button
                v-if="deuda.estado_actual.estado.id.trim() == 'PAGADO'"
                @click="
                  $router.push({
                    name: 'ver-recibo',
                    params: { nroComprobante: deuda.comprobante.numero_comprobante.trim() },
                  })
                "
                class="focus:shadow-outline inline-flex w-full items-center justify-center space-x-2 rounded-md border border-gray-300 bg-white px-4 py-3 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:border-blue-300 focus:outline-none sm:w-max"
              >
                <BoxIconReceipt class="h-5 w-5 fill-current" />
                <span>Ver recibo</span>
              </button>
              <button
                v-if="deuda.estado_actual.estado.habilita_pago"
                @click="$router.push({ name: 'pagar-comprobante', params: { idDeuda: deuda.id } })"
                class="focus:shadow-outline inline-flex w-full items-center justify-center space-x-2 rounded-md border border-gray-300 bg-white px-4 py-3 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:border-blue-300 focus:outline-none sm:w-max"
              >
                <BoxIconDollarCircle class="h-5 w-5 fill-current" />
                <span>Pagar comprobante</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import Vue from 'vue'

Vue.directive('tippy', {
  bind(el, binding) {
    tippy(el, {
      content: binding.value,
    })
  },
})
export default {
  name: 'ListaDeudas',

  props: ['deudas'],

  data() {
    return {
      infoEstados: {
        PAGADO: {
          backgroundColor: 'bg-green-200',
          textColor: 'text-green-600',
        },
        PAGO_PROCESADO: {
          backgroundColor: 'bg-green-200',
          textColor: 'text-green-600',
        },
        CREADO: {
          backgroundColor: 'bg-gray-200',
          textColor: 'text-gray-600',
        },
        PUBLICADO: {
          backgroundColor: 'bg-blue-200',
          textColor: 'text-blue-600',
        },
        PAGO_EN_PROCESO: {
          backgroundColor: 'bg-amber-200',
          textColor: 'text-amber-600',
        },
        ERROR_PAGO: {
          backgroundColor: 'bg-red-200',
          textColor: 'text-red-600',
        },
        PAGO_RECHAZADO: {
          backgroundColor: 'bg-red-200',
          textColor: 'text-red-600',
        },
        PAGO_INVIABLE: {
          backgroundColor: 'bg-red-200',
          textColor: 'text-red-600',
        },
        DEVUELTO: {
          backgroundColor: 'bg-violet-200',
          textColor: 'text-violet-600',
        },
        VENCIDO: {
          backgroundColor: 'bg-orange-200',
          textColor: 'text-orange-600',
          hideActions: true,
        },
        ANULADO: {
          backgroundColor: 'bg-rose-200',
          textColor: 'text-rose-600',
          hideActions: true,
        },
      },
    }
  },

  methods: {
    validCategory(categoryId) {
      const validCategories = ['CSSPP', 'PREST', 'SALUD', 'CSSPCTA', 'CSSFD']
      return validCategories.includes(categoryId.trim())
    },
    backgroundColor(estado) {
      let infoEstado = this.infoEstados[estado.estado.id.trim()]
      return infoEstado ? infoEstado.backgroundColor : 'bg-gray-200'
    },
    textColor(estado) {
      let infoEstado = this.infoEstados[estado.estado.id.trim()]
      return infoEstado ? infoEstado.textColor : 'text-gray-600'
    },
    textoEstado(estado) {
      if (estado.detalle) {
        return estado.detalle.mensaje.capitalizeOnlyFirst()
      } else {
        return estado.estado.id.capitalizeOnlyFirst()
      }
    },
    hideActions(estado) {
      let infoEstado = this.infoEstados[estado.estado.id.trim()]
      return infoEstado.hideActions === true
    },
  },
}
</script>
